import { MakerResponse } from "@/web-client/api";
import clsx from "clsx";
import Image from "next/image";
import Link from "next/link";
import { FC } from "react";

type Props = {
  maker: MakerResponse;
};

export const MakerArchiveItem: FC<Props> = ({ maker }): JSX.Element => {
  return (
    <article className={clsx("relative flex flex-col gap-8")}>
      <div className="relative aspect-4/3 bg-white">
        <Link
          className="absolute inset-0"
          href={`/makers/${maker.id}`}
          aria-label={`${maker.name}のページ`}
        >
          <Image
            className="object-contain object-center p-12"
            src={
              maker.logo
                ? maker.logo.urls.small
                : "/imgs/default_maker_blank.png"
            }
            alt={maker.name}
            unoptimized={true}
            fill
          />
        </Link>
      </div>

      <div
        className={clsx(
          "w-full flex items-start gap-8 justify-between",
          "laptop:flex-col",
        )}
      >
        <h2 className="font-bold laptop:text-base text-sm">{maker.name}</h2>
        {maker.is_sample_requestable && (
          <span className="text-xs bg-gray-200 p-4 rounded-xs">
            サンプル請求可
          </span>
        )}
      </div>
    </article>
  );
};
